import React from 'react'
import resources from '../../../services'
import DataTable from '../../../composents/DataTable'
import MainPage from '../../../composents/MainPage'
import config from '../../../constants'
import { useAlert } from '../../../ui/Alert'

const title = 'Pay Back'
const headers = {
  icon: 'feather icon-credit-card',
  title,
  description: 'track and manage all pay back information',
}

const actionDisplay = {
  0: {
    display: 'Request',
    color: 'label-warning',
    next: { 1: 'Accept', 2: 'Process', 3: 'Decline' },
  },
  1: {
    display: 'Pending',
    color: 'label-info',
    next: { 2: 'Process', 3: 'Decline' },
    icon: 'icon-check',
  },
  2: {
    display: 'Processed',
    color: 'label-success',
    next: null,
  },
  3: {
    display: 'Decline',
    color: 'label-danger',
    next: null,
    icon: 'icon-x-square',
  },
}

export default function PayBackPage() {
  const { push } = useAlert()
  async function updatePayback(el, value, callback) {
    if (value != 2) {
      el = {
        ...el,
        status: value,
      }

      let res = await resources.payBack
        .update(el.id, el)
        .then((responses) => {
          return responses
        })
        .catch((error) => {
          return Object.assign({}, error).response
        })
      if (res.status === 200) {
        callback()
        push({
          success: true,
        })
      } else if (res.status === 403) {
        push({
          error: true,
          message: config.app.error,
        })
      }
    } else {
      window.location.replace('/clients/paybacks/edit/' + el.id)
    }
  }

  return (
    <MainPage headers={headers} show_search>
      <DataTable
        column={[
          {
            label: 'Consumer',
            field: 'consumer',
            render: ['surname'],
          },
          {
            label: 'Wallet',
            field: 'wallet',
          },
          {
            label: 'Pay Back',
            field: 'payBack',
          },
          {
            label: 'Balance',
            field: 'balance',
          },
          {
            label: 'Payment',
            field: 'payment',
          },
          {
            label: 'Status',
            field: 'status',
            renderStyle: (data) => {
              return (
                <p>
                  <label
                    className={`form-label label ${
                      actionDisplay[data.status]?.color || 'label-warning'
                    }`}
                  >
                    {actionDisplay[data.status]?.display || 'Request'}
                  </label>
                </p>
              )
            },
          },
        ]}
        resource={resources.payBack}
        title={title}
        update={false}
        deleteItem={false}
        link="/clients/paybacks"
        action={(data, callback) => {
          const action = actionDisplay[data.status || 0]
          if (action.next) {
            const steps = Object.keys(action.next)
            return steps.map((key) => (
              <li onClick={() => updatePayback(data, key, callback)}>
                <span
                  className="dropdown-item"
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  <i className={`feather ${actionDisplay[key]?.icon || 'icon-edit'}`}></i>{' '}
                  {action.next[key]}
                </span>
              </li>
            ))
          }
        }}
      />
    </MainPage>
  )
}
